import { render, staticRenderFns } from "./lessDeductionUnderChapterVIAPopup.vue?vue&type=template&id=4425fe01&scoped=true"
import script from "./lessDeductionUnderChapterVIAPopup.vue?vue&type=script&lang=js"
export * from "./lessDeductionUnderChapterVIAPopup.vue?vue&type=script&lang=js"
import style0 from "./lessDeductionUnderChapterVIAPopup.vue?vue&type=style&index=0&id=4425fe01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4425fe01",
  null
  
)

export default component.exports